export function serializeParams(params: { [key: string]: string | number | boolean | null | undefined }) {
    let arr = [];

    for (let p in params) {
        let param = params[p];

        if (params.hasOwnProperty(p) && param !== null && param !== undefined) {
            arr.push(encodeURIComponent(p) + "=" + encodeURIComponent(param));
        }
    }

    return arr.join("&");
}